// @ts-check
import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { DeliveryPartner } from "@assets/svg/MyDeliveries";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import { MY_DELIVERY_EVENTS } from "@constants/analyticsEventsCT";
import { normalize } from "@constants/metrics";
import { colors } from "@constants/theme";
import CallIcon from "@assets/svg/newCall";
import t from "@constants/localization";

const PATH = "screens/MyDeliveries/DeliveryReturn/DeliveryCard";
const onPressCall = (phone) => {
  handleCallButtonPress(phone, MY_DELIVERY_EVENTS.DB_CALLED, {
    screen: "My Delivery",
  });
};
const DeliveryBoyInfoComponent = ({ deliveryBoyInfo }) => {
  return (
    <>
      <View style={styles.deliveryPartnerBox}>
        <View style={styles.deliveryPartnerInnerLeftBox}>
          <DeliveryPartner
            status={deliveryBoyInfo?.status}
            width={normalize(48)}
            height={normalize(48)}
          />
          <View style={styles.partnerDetails}>
            {deliveryBoyInfo?.delivery_boy_name ? (
              <View>
                <Text style={styles.partner}>{t(`${PATH}/partner`)}</Text>
                <Text style={styles.name}>
                  {deliveryBoyInfo?.delivery_boy_name}
                </Text>
              </View>
            ) : (
              <View>
                <Text style={styles.name}>
                  {t(`${PATH}/assigningDeliveryPartners`)}
                </Text>
                <Text style={styles.partner}>{t(`${PATH}/willUpdate`)}</Text>
              </View>
            )}
          </View>
        </View>
        {deliveryBoyInfo?.delivery_boy_phone && (
          <TouchableOpacity
            testID="onPressDeliveryBoyPhone"
            style={styles.button}
            onPress={() => onPressCall(deliveryBoyInfo?.delivery_boy_phone)}
          >
            <CallIcon
              strokeColor="#ffffff"
              width={normalize(17)}
              height={normalize(17)}
            />
          </TouchableOpacity>
        )}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  deliveryPartnerBox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  deliveryPartnerInnerLeftBox: {
    flexDirection: "row",
    flex: 0.9,
  },
  partnerDetails: {
    flex: 1,
    justifyContent: "center",
    paddingLeft: 15,
  },
  button: {
    width: normalize(32),
    height: normalize(32),
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#2195F2",
    borderRadius: 20,
  },
  partner: {
    fontSize: 12,
    color: colors.extraLightBlack,
    alignItems: "center",
    lineHeight: 20,
  },
  name: {
    fontSize: 14,
    color: colors.mediumBlack,
    alignItems: "center",
    lineHeight: 20,
    fontFamily: "NotoSansDevanagari-Bold",
  },
});

export default DeliveryBoyInfoComponent;
